import React, {Suspense} from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const MatchFactsWidgetAsyncComponent = AsyncComponent(async () => import('./match-facts-widget' /* webpackChunkName: "match-facts-widget" */ ));

export const MatchFactsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper isMandatory>
    <Suspense fallback={<div />}>
      <MatchFactsWidgetAsyncComponent {...props}/>
    </Suspense>
  </ErrorBoundaryWrapper>
};
